import React from "react";
import "./prijava.css";
import { Link } from "react-router-dom";

const PrijavaSaPl = () => {
  return (
    <div className="pocetna-container container mb-5">
      <div className="modal-overlay">
        <div className="modal-box">
          <h2>Prijave uz merch su završile 😔</h2>
        
          <p>Sada možeš poslati klasičnu prijavu bez majice.</p>

          <Link to="/prijavabezpl" className="btn mt-3">
            Pošalji klasičnu prijavu
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrijavaSaPl;